module.exports = __webpack_public_path__ + "img/tap-to-spin-roulette.c5ca1d32.png";